'use strict';
/**
 * Exception that rises when the peer looked for does not exist in the partial
 * view.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var ExPeerNotFound =
/**
   * @param {string} source The function that throw the error.
   * @param {string} [peerId = 'unknown'] The identifier of the peer if
   * defined.
   */
function ExPeerNotFound(source) {
  var peerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';

  _classCallCheck(this, ExPeerNotFound);

  this.source = source;
  this.peer = peerId;
};

module.exports = ExPeerNotFound;